import React from 'react'

import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import Spinner from 'react-spinkit'

//TODO: add types for react-spinkit

const useStyles = makeStyles((theme) => ({
  loader: {
    height: '22px',
    '& > div': {
      height: '22px',
    },
    color: `${theme.palette.primary.main}`,
  },
}))

const Loading = () => {
  const classes = useStyles()

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item>
        <Spinner
          fadeIn="quarter"
          name="line-scale-pulse-out"
          className={classes.loader}
        />
      </Grid>
    </Grid>
  )
}

export default Loading
